import type { PluralFunc } from 'nuxt-i18n-micro'

export const plural: PluralFunc = (key, count, _params, locale, translate) => {
  const translation = translate(key)

  if (!translation) {
    return key
  }

  const forms = translation
    .toString()
    .split('|')
    .map((f) => f.trim())

  if (forms.length === 1) {
    return forms[0]?.replace('{count}', String(count)) ?? ''
  }

  let index = 0

  switch (locale) {
    case 'be':
    case 'ru':
    case 'uk':
      // Русская логика
      if (count === -1) {
        index = 0
      } else if (count % 10 === 1 && count % 100 !== 11) {
        index = 1 // 1 файл
      } else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
        index = 2 // 2 файла
      } else {
        index = 0 // 5 файлов
      }
      break

    default:
      // Английская логика (singular/plural)
      index = count === 1 ? 0 : 1
      break
  }
  const form = forms[index] ?? forms[forms.length - 1]

  return form?.replace('{count}', String(count)) ?? ''
}
